import { useReducer, useState } from "react";

import "./Form.css";

const initialState = {
    salario: 0,
    tiene_inmuebles: false,
    cantidad_inmuebles: 0,
    valuacion_inmueble1: 0,
    valuacion_inmueble2: 0,
    valuacion_inmueble3: 0,
    valuacion_inmueble4: 0,
    tiene_auto: false,
    cantidad_auto: 0,
    valuacion_auto1: 0,
    valuacion_auto2: 0,
    valuacion_auto3: 0,
    valuacion_auto4: 0,
    modelo_auto: null
};

function reducer(state, action) {
    switch (action.type) {
        case 'salario':
            return {
                ...state,
                salario: action.payload
            }
        case 'tiene_inmuebles':
            return {
                ...state,
                tiene_inmuebles: action.payload
            }
        case 'cantidad_inmuebles':
            return {
                ...state,
                cantidad_inmuebles: action.payload
            }
        case 'val_inm1':
            return {
                ...state,
                valuacion_inmueble1: action.payload
            }
        case 'val_inm2':
            return {
                ...state,
                valuacion_inmueble2: action.payload
            }
        case 'val_inm3':
            return {
                ...state,
                valuacion_inmueble3: action.payload
            }
        case 'val_inm4':
            return {
                ...state,
                valuacion_inmueble4: action.payload
            }
        case 'tiene_auto':
            return {
                ...state,
                tiene_auto: action.payload
            }
        case 'cantidad_auto':
            return {
                ...state,
                cantidad_auto: action.payload
            }
        case 'val_aut1':
            return {
                ...state,
                valuacion_auto1: action.payload
            }
        case 'val_aut2':
            return {
                ...state,
                valuacion_auto2: action.payload
            }
        case 'val_aut3':
            return {
                ...state,
                valuacion_auto3: action.payload
            }
        case 'val_aut4':
            return {
                ...state,
                valuacion_inmueble4: action.payload
            }
        case 'modelo_auto':
            return {
                ...state,
                modelo_auto: action.payload
            }
        default:
            throw new Error();
    }
}

function Form() {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [resultado, setResultado] = useState();

    function calculateHandler(ev) {
        ev.preventDefault();
        const dinero_por_dia = state.salario / 30;

        let { valuacion_inmueble1, valuacion_inmueble2, valuacion_inmueble3, valuacion_inmueble4 } = state;
        let { valuacion_auto1, valuacion_auto2, valuacion_auto3, valuacion_auto4 } = state;

        valuacion_inmueble1 = parseInt(valuacion_inmueble1);
        valuacion_inmueble2 = parseInt(valuacion_inmueble2);
        valuacion_inmueble3 = parseInt(valuacion_inmueble3);
        valuacion_inmueble1 = parseInt(valuacion_inmueble1);
        valuacion_auto1 = parseInt(valuacion_auto1);
        valuacion_auto2 = parseInt(valuacion_auto2);
        valuacion_auto3 = parseInt(valuacion_auto3);
        valuacion_auto4 = parseInt(valuacion_auto4);

        let valor_inmuebles = valuacion_inmueble1 + valuacion_inmueble2 + valuacion_inmueble3 + valuacion_inmueble4;

        let inmuebles_porcentaje = (valor_inmuebles * 3.5) / 100;

        console.log(typeof valuacion_inmueble1)

        /* Autos */

        let valor_autos = valuacion_auto1 + valuacion_auto2 + valuacion_auto3 + valuacion_auto4;
        let modelo_auto = state.modelo_auto;

        let autos_porcentajes;
        if (modelo_auto === 'Menos de 10 años') {
            autos_porcentajes = (valor_autos * 4.5) / 100;
        }
        else if (modelo_auto === 'Más de 10 años') {
            autos_porcentajes = (valor_autos * 4) / 100;
        } else {
            autos_porcentajes = (valor_autos * 4.5) / 100;
        }

        if (autos_porcentajes) console.log(autos_porcentajes);

        let resultado = (inmuebles_porcentaje + autos_porcentajes) / dinero_por_dia;

        setResultado(resultado);
    }

    return (
        <>
            <div className="form-container">
                <form onSubmit={calculateHandler}>
                    <label htmlFor="sueldo">Sueldo Neto Mensual</label>
                    <input
                        type="number"
                        id="sueldo"
                        name="sueldo"
                        onChange={(ev) => dispatch({ type: 'salario', payload: ev.target.value })}
                        placeholder="Salario"
                        required
                    />
                    <input
                        type="checkbox"
                        id="tiene_inmuebles"
                        name="tiene_inmuebles"
                        onChange={(ev) => dispatch({ type: 'tiene_inmuebles', payload: ev.target.checked })}
                    />
                    <label htmlFor="tiene_inmuebles"><span></span> ¿Tienes Inmuebles?</label>
                    {state.tiene_inmuebles ? (
                        <input
                            type="number"
                            name="cantidad_inmuebles"
                            required
                            onChange={(ev) => dispatch({ type: 'cantidad_inmuebles', payload: ev.target.value })}
                            placeholder="Cantidad de inmuebles"
                        />
                    ) : ''}
                    {
                        state.cantidad_inmuebles === '1' ? (
                            <div className="input_container">
                                <input
                                    type="number"
                                    name="val_inmueble1"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_inm1', payload: ev.target.value })}
                                    placeholder="Valuación fiscal del inmueble 1"
                                />
                            </div>
                        ) : ""
                    }
                    {
                        state.cantidad_inmuebles === '2' ? (
                            <div className="input_container">
                                <input
                                    type="number"
                                    name="val_inmueble1"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_inm1', payload: ev.target.value })}
                                    placeholder="Valuación fiscal del inmueble 1"
                                />
                                <input
                                    type="number"
                                    required
                                    name="val_inmueble2" onChange={(ev) => dispatch({ type: 'val_inm2', payload: ev.target.value })}
                                    placeholder="Valuación fiscal del inmueble 2"
                                />
                            </div>
                        ) : ""
                    }
                    {
                        state.cantidad_inmuebles === '3' ? (
                            <div className="input_container">
                                <input
                                    type="number"
                                    name="val_inmueble1"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_inm1', payload: ev.target.value })}
                                    placeholder="Valuación fiscal del inmueble 1"
                                />
                                <input
                                    type="number"
                                    name="val_inmueble2"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_inm2', payload: ev.target.value })}
                                    placeholder="Valuación fiscal del inmueble 2"
                                />
                                <input
                                    type="number"
                                    name="val_inmueble3"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_inm3', payload: ev.target.value })}
                                    placeholder="Valuación fiscal del inmueble 3"
                                />
                            </div>
                        ) : ""
                    }
                    {
                        state.cantidad_inmuebles === '4' ? (
                            <div className="input_container">
                                <input
                                    type="number"
                                    name="val_inmueble1"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_inm1', payload: ev.target.value })}
                                    placeholder="Valuación fiscal del inmueble 1"
                                />
                                <input
                                    type="number"
                                    name="val_inmueble2"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_inm2', payload: ev.target.value })}
                                    placeholder="Valuación fiscal del inmueble 2"
                                />
                                <input
                                    type="number"
                                    name="val_inmueble3"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_inm3', payload: ev.target.value })}
                                    placeholder="Valuación fiscal del inmueble 3"
                                />
                                <input
                                    type="number"
                                    name="val_inmueble4"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_inm4', payload: ev.target.value })}
                                    placeholder="Valuación fiscal del inmueble 4"
                                />
                            </div>
                        ) : ""
                    }
                    <input
                        type="checkbox"
                        id="tiene_auto"
                        onChange={(ev) => dispatch({ type: 'tiene_auto', payload: ev.target.checked })}
                    />
                    <label htmlFor="tiene_auto"><span></span> ¿Tienes Automotor?</label>
                    {
                        state.tiene_auto ? (
                            <>
                                <input
                                    type="number"
                                    onChange={(ev) => dispatch({ type: 'cantidad_auto', payload: ev.target.value })}
                                    required
                                    name="cantidad_auto"
                                    placeholder="Cantidad de automotores"
                                />
                                <div className="caja">
                                    <select defaultValue="Menos de 10 años" name="auto_modelo" onChange={(ev) => dispatch({ type: 'modelo_auto', payload: ev.target.value })}>
                                        <option>Menos de 10 años</option>
                                        <option>Más de 10 año</option>
                                    </select>
                                </div>
                            </>
                        ) : ""
                    }
                    {
                        state.cantidad_auto === '1' ? (
                            <div className="input_container">
                                <input
                                    type="number"
                                    name="val_auto1"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_aut1', payload: ev.target.value })}
                                    placeholder="Valuación del automotor 1 (DNRA)"
                                />
                            </div>
                        ) : ""
                    }
                    {
                        state.cantidad_auto === '2' ? (
                            <div className="input_container">
                                <input
                                    type="number"
                                    name="val_auto1"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_aut1', payload: ev.target.value })}
                                    placeholder="Valuación del automotor 1 (DNRA)"
                                />
                                <input
                                    type="number"
                                    name="val_auto2"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_aut2', payload: ev.target.value })}
                                    placeholder="Valuación del automotor 2 (DNRA)"
                                />
                            </div>
                        ) : ""
                    }
                    {
                        state.cantidad_auto === '3' ? (
                            <div className="input_container">
                                <input
                                    type="number"
                                    name="val_auto1"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_aut1', payload: ev.target.value })}
                                    placeholder="Valuación del automotor 1 (DNRA)"
                                />
                                <input
                                    type="number"
                                    name="val_auto2"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_aut2', payload: ev.target.value })}
                                    placeholder="Valuación del automotor 2 (DNRA)"
                                />
                                <input
                                    type="number"
                                    name="val_auto3"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_aut3', payload: ev.target.value })}
                                    placeholder="Valuación del automotor 3 (DNRA)"
                                />
                            </div>
                        ) : ""
                    }
                    {
                        state.cantidad_auto === '4' ? (
                            <div className="input_container">
                                <input
                                    type="number"
                                    name="val_auto1"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_aut1', payload: ev.target.value })}
                                    placeholder="Valuación del automotor 1 (DNRA)"
                                />
                                <input
                                    type="number"
                                    name="val_auto2"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_aut2', payload: ev.target.value })}
                                    placeholder="Valuación del automotor 2 (DNRA)"
                                />
                                <input
                                    type="number"
                                    name="val_auto3"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_aut3', payload: ev.target.value })}
                                    placeholder="Valuación del automotor 3 (DNRA)"
                                />
                                <input
                                    type="number"
                                    name="val_auto4"
                                    required
                                    onChange={(ev) => dispatch({ type: 'val_aut4', payload: ev.target.value })}
                                    placeholder="Valuación del automotor 4 (DNRA)"
                                />
                            </div>
                        ) : ""
                    }
                    <button type="submit">Calcular</button>
                </form>
            </div>
            <div className="resultado-container">
                {resultado ? (
                    <h2>Resultado: {resultado} días</h2>
                ) : (
                    <h2>Resultado: 0 días</h2>
                )}
            </div>
            <div className="info-container">
                <img src="/img/lucas_yacob.jpg" alt="Foto de Lucas Yacob" className="lucas_yacob" />
                <p>Lucas Yacob</p>
                <img src="/img/unnamed.png" alt="" className="bar" />
                <p>Concejal</p>
            </div>
        </>
    )
}

export default Form;